export type AvailabilityType = 'api' | 'integration' | 'both' | null;

export interface SavedQuery {
  id: string;
  name: string;
  description: string | null;
  sql_query: string;
  endpoint_slug: string;
  selected_columns: string[];
  filter_columns: string[];
  availability_type: AvailabilityType;
  documentation_description: string | null;
  is_active: boolean;
  automation_enabled: boolean;
  automation_webhook_url: string | null;
  automation_interval: AutomationInterval | null;
  automation_last_run: string | null;
  automation_next_run: string | null;
  integration_solace_enabled: boolean;
  integration_solace_broker_url: string | null;
  integration_solace_vpn_name: string | null;
  integration_solace_queue_name: string | null;
  integration_solace_username: string | null;
  integration_solace_password: string | null;
  integration_solace_interval: AutomationInterval | null;
  integration_solace_last_run: string | null;
  integration_solace_next_run: string | null;
  integration_sap_btp_enabled: boolean;
  integration_sap_btp_service_url: string | null;
  integration_sap_btp_client_id: string | null;
  integration_sap_btp_client_secret: string | null;
  integration_sap_btp_token_url: string | null;
  integration_sap_btp_api_path: string | null;
  integration_sap_btp_interval: AutomationInterval | null;
  integration_sap_btp_last_run: string | null;
  integration_sap_btp_next_run: string | null;
  created_at: string;
  updated_at: string;
}

export type AutomationInterval = '5min' | '15min' | '30min' | '1h' | '6h' | '12h' | '24h';

export const AUTOMATION_INTERVALS: { value: AutomationInterval; label: string }[] = [
  { value: '5min', label: 'A cada 5 minutos' },
  { value: '15min', label: 'A cada 15 minutos' },
  { value: '30min', label: 'A cada 30 minutos' },
  { value: '1h', label: 'A cada 1 hora' },
  { value: '6h', label: 'A cada 6 horas' },
  { value: '12h', label: 'A cada 12 horas' },
  { value: '24h', label: 'A cada 24 horas' },
];

export interface CreateQueryRequest {
  name: string;
  description?: string;
  sql_query: string;
  endpoint_slug?: string;
  selected_columns?: string[];
  filter_columns?: string[];
  availability_type?: AvailabilityType;
  documentation_description?: string;
  is_active?: boolean;
  automation_enabled?: boolean;
  automation_webhook_url?: string;
  automation_interval?: AutomationInterval;
  integration_solace_enabled?: boolean;
  integration_solace_broker_url?: string;
  integration_solace_vpn_name?: string;
  integration_solace_queue_name?: string;
  integration_solace_username?: string;
  integration_solace_password?: string;
  integration_solace_interval?: AutomationInterval;
  integration_sap_btp_enabled?: boolean;
  integration_sap_btp_service_url?: string;
  integration_sap_btp_client_id?: string;
  integration_sap_btp_client_secret?: string;
  integration_sap_btp_token_url?: string;
  integration_sap_btp_api_path?: string;
  integration_sap_btp_interval?: AutomationInterval;
}

export interface UpdateQueryRequest {
  name?: string;
  description?: string;
  sql_query?: string;
  endpoint_slug?: string;
  selected_columns?: string[];
  filter_columns?: string[];
  availability_type?: AvailabilityType;
  documentation_description?: string;
  is_active?: boolean;
  automation_enabled?: boolean;
  automation_webhook_url?: string;
  automation_interval?: AutomationInterval;
  integration_solace_enabled?: boolean;
  integration_solace_broker_url?: string;
  integration_solace_vpn_name?: string;
  integration_solace_queue_name?: string;
  integration_solace_username?: string;
  integration_solace_password?: string;
  integration_solace_interval?: AutomationInterval;
  integration_sap_btp_enabled?: boolean;
  integration_sap_btp_service_url?: string;
  integration_sap_btp_client_id?: string;
  integration_sap_btp_client_secret?: string;
  integration_sap_btp_token_url?: string;
  integration_sap_btp_api_path?: string;
  integration_sap_btp_interval?: AutomationInterval;
}

export interface QueryExecutionResult {
  success: boolean;
  data: Record<string, unknown>[];
  columns: string[];
  rowCount: number;
  executionTime: number;
  error?: string;
}
